module.exports = __webpack_public_path__ + "static/logistic-model-3a70c00d2514c13ee099e10bb3cbaa94.svg";